import moment from 'moment';

const EXPORTS = {
	"EXPIRATION_DAYS": 35
};

export function expiresOn(date, expirationDays = EXPORTS.EXPIRATION_DAYS) {
  return moment(date).add(expirationDays, 'd');
};

export default function hasExpired(date, expirationDays = EXPORTS.EXPIRATION_DAYS) {
  return moment().isAfter(expiresOn(date, expirationDays));
};
